import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgInstallments32 = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 32 32"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <defs>
        <path
          id="installments-32_svg__a"
          d="M30 16H16v14c-7.587-.225-13.77-6.048-13.994-13.575C1.78 8.82 7.811 2.323 15.411 2.012 23.411 1.685 30 8.072 30 16m-9.553 10.065a1.638 1.638 0 1 1 0 3.276 1.638 1.638 0 0 1 0-3.276m5.613-.87a1.64 1.64 0 0 1 0 3.278 1.638 1.638 0 0 1 0-3.278m-5.006-5.328a1.638 1.638 0 1 1 0 3.277 1.638 1.638 0 0 1 0-3.277m6.31-.646a1.64 1.64 0 1 1 0 3.28 1.64 1.64 0 0 1 0-3.281z"
        />
      </defs>
      <g>
        <mask id="installments-32_svg__b">
          <use xlinkHref="#installments-32_svg__a" />
        </mask>
        <use xlinkHref="#installments-32_svg__a" />
        <g mask="url(#installments-32_svg__b)">
          <path d="M0 0h32v32H0z" />
        </g>
      </g>
    </SvgIcon>
  );
};
const Memo = memo(SvgInstallments32);
export default Memo;
